<template>
  <v-dialog
    v-if="dialogs.drawer || this.$vuetify.breakpoint.xsOnly"
    max-width="500"
    :value="dialogs.idRequired"
    @click:outside="$store.dispatch('cart/setIdRequiredDialog', false)"
  >
    <v-card class="py-10 px-7">
      <CloseDialogButton
        :close="() => $store.dispatch('cart/setIdRequiredDialog', false)"
      />
      <v-row no-gutters>
        <v-col class="d-flex justify-center">
          <v-icon class="mdi-card-account-details-outline"
            >mdi-card-account-details-outline</v-icon
          >
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col class="font-size-lg mb-12 mt-6 text-center">
          Your order contains alcohol or tobacco items. You will be required to
          show your ID to receive your order.
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col class="text-center">
          <v-btn
            color="primary"
            height="48"
            width="180"
            @click="$store.dispatch('cart/setIdRequiredDialog', false)"
            rounded
          >
            <div class="font-size-md text-capitalize">i understand</div>
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import CloseDialogButton from "@/components/UI/CloseDialogButton.vue";

export default {
  name: "IdRequiredDialog",
  components: { CloseDialogButton },
  computed: {
    ...mapGetters("cart", {
      containsAlcoholOrTobacco: "containsAlcoholOrTobacco",
    }),
    ...mapState({
      dialogs: (state) => state.cart.dialogs,
    }),
  },
  watch: {
    "$store.state.cart.dialogs.drawer": function (open) {
      // smAndUp
      this.$store.dispatch(
        "cart/setIdRequiredDialog",
        this.containsAlcoholOrTobacco && open
      );
    },
    $route(to, from) {
      // xsOnly
      if (
        !this.$vuetify.breakpoint.xsOnly ||
        to.name !== "cart" ||
        from.name === "checkout"
      ) {
        return;
      }
      this.$store.dispatch(
        "cart/setIdRequiredDialog",
        this.containsAlcoholOrTobacco
      );
    },
  },
};
</script>
<style scoped>
.mdi-card-account-details-outline {
  color: var(--v-primary-base);
  font-size: 85px;
}
</style>
